import { render, staticRenderFns } from "./words.vue?vue&type=template&id=7c3439e6"
import script from "./words.vue?vue&type=script&lang=ts"
export * from "./words.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports